export default "__VITE_ASSET__r9JJRWiO__"